export default __webpack_public_path__ + "static/media/roadmap1.05c3138f.png";